<template>
  <!-- # 5.3.3	债券到期现金流 -->
  <el-container class="main_container w100">
    <el-main :class="{'ismobilePhone':isMobilePhone}">
      <div class="DataModule full_height">
        <el-row style="overflow-y: auto; height:100%;">
          <!-- Revised on 2022-03-05  -->
          <el-table
            :data="table_data"
            border
            style="width: 100%"
            height="100%"
            stripe
            fit
            :header-cell-style="{textAlign: 'center'}"
            id="table"
          >
            <!-- Revised on 2022-03-05  -->
            <el-table-column
              prop=a1
              align="center"
              :label=row_keys.a1
            />
            <el-table-column
              prop=a2
              align="right"
              :label=row_keys.a2
            />
            <el-table-column
              prop=a3
              align="right"
              :label=row_keys.a3
            />
            <el-table-column
              prop=a4
              align="right"
              :label=row_keys.a4
            />
            <el-table-column
              prop=a5
              align="right"
              :label=row_keys.a5
            />
          </el-table>
        </el-row>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { get_cash_flow } from 'common/js/http/v3Api'
import { exportTableData } from 'common/js/utils/utils'

export default {
  name: "cash_flow",
  data() {
    return {
      row_keys: {
        // "a0":"发表类型",
        // "a1":"现金流发生日",
        // "a2":"百元面额现金流合计(元)",
        // "a3":"百元面额派息现金流(元)",
        // "a4":"百元面额兑付现金流(元)",
        // "a5":"现金流类型",
        // "a6":"副票面利率"
        "a0": "Publication type",
        "a1": "Cash flow date",
        "a2": "Total cash flow of 100 yuan denomination (yuan)",
        "a3": "Cash flow of dividend distribution with face value of 100 yuan (yuan)",
        "a4": "Cash flow of 100 yuan face value (yuan)",
        "a5": "Type of cash flow",
        "a6": "Coupon rate"
      },
      isMobilePhone: false,
      stockCode: '120303.SH',
      table_data: null
    };
  },

  mounted() {
    this.stockCode = this.$route.query.stockCode
    this.get_cash_flow()
  },
  methods: {
    async get_cash_flow() {
      const { data } = await get_cash_flow({
        trd_code: this.stockCode,
      });
      const rows = data.result.data.rows;
      this.table_data = rows
    },
    async searchTableData(item) {
      if (item) {
        this.stockCode = item;
        this.get_cash_flow()
      }
    },
    /* Revised on 2022-03-05  */
    exportTableData() {
      let html = document.getElementById("table").outerHTML.replace(/<(\w+) (.+?)>/g, (m, p1) => `<${p1}>`)
        .replace('<table>', '<table border>')
      // vnd.ms-excel.numberformat:@; 格式化文本
      // xmlns 和 head 中 用于显示网格线
      html = `<html xmlns:x="urn:schemas-microsoft-com:office:excel">
            <head>
              <xml>
                <x:ExcelWorkbook>
                  <x:ExcelWorksheets>
                    <x:ExcelWorksheet>
                      <x:WorksheetOptions>
                        <x:Print><x:ValidPrinterInfo /></x:Print>
                      </x:WorksheetOptions>
                    </x:ExcelWorksheet>
                  </x:ExcelWorksheets>
                </x:ExcelWorkbook>
              </xml>
            </head>
            <style>
              table{vnd.ms-excel.numberformat:@;}
            </style>
              ${html}
            </html>`
      let blob = new Blob([html], { type: 'application/octet-stream' })
      let url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.download = 'cash_flow.xlsx' // 重命名文件
      link.click()
      window.URL.revokeObjectURL(url) // 释放内存
    }
    /* Revised on 2022-03-05  */
  }

};
</script>

<style scoped>
.ismobilePhone {
  padding: 0 !important;
  background: #fff !important;
}
.bgw {
  background: #fff;
}
.w100 {
  width: 100%;
}
.el-main {
  padding: 0;
  height: 100%;
}

table {
  height: calc(100% - 30px);
  width: 100%;
  padding: 10px 0;
}
tr:nth-of-type(odd) {
  background-color: #f2f2f2;
}
tr:nth-of-type(even) {
  background-color: #ffffff;
}
td {
  text-indent: 10px;
  word-wrap: break-word !important;
  overflow: visible !important;
  white-space: normal !important;
  text-overflow: ellipsis;
  border: 0;
  border-right: 1px solid #cacaca;
  height: 32px;
}
.w20 {
  width: 20%;
}
.w80 {
  width: 80%;
}
</style>
